import type { SVGProps } from "react";

// Line icons for the public event page, sized via `size` (default 18) and inheriting
// `currentColor`. Paths mirror the restomag-website events module so the two surfaces
// read identically.

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Icon({ size = 18, strokeWidth = 2, children, ...props }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export const IconPerson = (p: IconProps) => (
  <Icon {...p}>
    <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM4 20a8 8 0 0116 0" />
  </Icon>
);

export const IconMail = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 7l9 6 9-6M4 5h16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1z" />
  </Icon>
);

export const IconPhone = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 5a2 2 0 012-2h2.4a1 1 0 01.97.757l1.1 4.4a1 1 0 01-.27.95l-1.6 1.6a14 14 0 006.3 6.3l1.6-1.6a1 1 0 01.95-.27l4.4 1.1a1 1 0 01.757.97V19a2 2 0 01-2 2h-1C9.06 21 3 14.94 3 7V6z" />
  </Icon>
);

export const IconCar = (p: IconProps) => (
  <Icon {...p}>
    <path d="M5 16v2m14-2v2M4 13l1.5-4.5A2 2 0 017.4 7h9.2a2 2 0 011.9 1.5L20 13m-16 0h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1zm2.5 2h.01m10.99 0h.01" />
  </Icon>
);

export const IconCalendar = (p: IconProps) => (
  <Icon {...p}>
    <path d="M8 3v3m8-3v3M4 8h16M5 6h14a1 1 0 011 1v12a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1z" />
  </Icon>
);

export const IconPin = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 21s7-5.2 7-11a7 7 0 10-14 0c0 5.8 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </Icon>
);

export const IconTrophy = (p: IconProps) => (
  <Icon {...p}>
    <path d="M8 4h8v4a4 4 0 11-8 0V4zM8 6H5v1a3 3 0 003 3m8-4h3v1a3 3 0 01-3 3m-4 4v3m-3 3h6" />
  </Icon>
);

export const IconLock = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6 10V8a6 6 0 1112 0v2m-9 0h6a3 3 0 013 3v5a1 1 0 01-1 1H7a1 1 0 01-1-1v-5a3 3 0 013-3z" />
  </Icon>
);

export const IconArrowUpRight = (p: IconProps) => (
  <Icon {...p}>
    <path d="M7 17L17 7M9 7h8v8" />
  </Icon>
);

export const IconCheck = (p: IconProps) => (
  <Icon strokeWidth={2.5} {...p}>
    <path d="M5 13l4 4L19 7" />
  </Icon>
);

export const IconShieldCheck = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6l7-3z" />
    <path d="M9 12l2 2 4-4" />
  </Icon>
);

export const IconChevronDown = (p: IconProps) => (
  <Icon {...p}>
    <path d="M19 9l-7 7-7-7" />
  </Icon>
);

export const IconWarning = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 3.5l9 16H3l9-16z" />
    <path d="M12 10v4" />
    <path d="M12 17h.01" />
  </Icon>
);
